import type { McpServer, McpTool, SelectionChip } from "./types";

export function toSelectionChip(
  server: McpServer,
  selectedCount: number
): SelectionChip {
  return {
    id: server.name,
    name: server.displayName,
    toolkitId: server.name,
    selectedCount,
    total: server.tools.length,
    isPartial: selectedCount < server.tools.length,
  };
}

export function toToolCardProps(tool: McpTool) {
  return {
    description: tool.description,
    destructive: tool.metadata?.behavior?.destructive,
    name: tool.name,
    rawName: tool.fully_qualified_name,
    readOnly: tool.metadata?.behavior?.read_only,
    version: tool.toolkit.version ?? "",
  };
}

export function plural(
  n: number,
  singular: string,
  pluralForm?: string
): string {
  return `${n} ${n === 1 ? singular : (pluralForm ?? `${singular}s`)}`;
}
